import { Box } from '@mui/material';
import CustomLoader from 'components/shared/CustomLoader/CustomLoader';
import InfiniteScrollColumn from 'components/shared/InfiniteScrollColumn/InfiniteScrollColumn';
import { ClientDataType, ClientType, InfiniteScrollData } from 'model/client.model';
import { Link } from 'react-router-dom';
import zeplinColor from 'theme/Color';
import CustomClientCard from './CustomClientCard';

const ClientColumnGrid = ({
  clients,
  loading,
  category,
  infiniteScroll,
}: {
  clients: ClientDataType;
  loading: boolean;
  category: string | null;
  infiniteScroll?: InfiniteScrollData;
}) => {
  if (loading)
    return (
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: 'calc(100vh - 190px)',
        }}
      >
        <CustomLoader open={true} />
      </Box>
    );

  const displayedClients =
    category === 'all'
      ? (clients?.clients ?? [])
      : (clients?.clients ?? []).filter((val) => val.category === category);

  return (
    <InfiniteScrollColumn
      dataVal={{
        records: displayedClients,
        totalRecords: infiniteScroll?.totalCount ?? displayedClients.length,
      }}
      next={async (offset) => {
        if (offset && infiniteScroll) await infiniteScroll.fetchMore();
      }}
      loading={infiniteScroll?.loading || loading}
      total={infiniteScroll?.totalCount ?? displayedClients.length}
      height='calc(100vh - 190px)'
      loaderComponent={<CustomLoader open={true} />}
      render={() => null}
      paddingBottom='2rem'
    >
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'repeat(auto-fill, minmax(250px, 1fr))',

            xl: 'repeat(auto-fill, minmax(300px, 1fr))',
          },
          gap: '24px',
          gridAutoRows: 'min-content',
          gridAutoFlow: 'row',
          alignItems: 'start',
          '& > a': {
            height: 'auto',
            display: 'block',
          },
        }}
      >
        {displayedClients?.map((val: ClientType) => (
          <Link
            to={`huddle/${val.AccountId}`}
            state={{ client: val }}
            style={{ textDecoration: 'none', color: zeplinColor.BasicBlack }}
            key={val?.AccountId}
            onClick={() => sessionStorage.setItem('selectedClient', JSON.stringify(val))}
          >
            <CustomClientCard key={val.AccountId} client={val} loading={false} />
          </Link>
        ))}
      </Box>
    </InfiniteScrollColumn>
  );
};

export default ClientColumnGrid;
